import {
  IconAi,
  IconBusSide,
  IconMailbox,
  IconMeta,
  IconMicrophoneOutline,
  IconMultipleUsersOutline,
  IconNewspaper,
  IconPhoneFilled,
  IconPlusCircle,
  IconSpeech,
  IconYoutube,
  IconZoomOutline,
} from '@iwoca/icons';

export function getPollIcon(answerValue: string) {
  switch (answerValue) {
    case 'letter':
      return (
        <IconMailbox role="img" width={24} height={24} aria-label="mailbox" />
      );
    case 'search_engine':
      return (
        <IconZoomOutline
          role="img"
          width={24}
          height={24}
          aria-label="zoomOutline"
        />
      );
    case 'word_of_mouth':
      return (
        <IconSpeech
          role="img"
          width={24}
          height={24}
          aria-label="speech"
          fill="none"
        />
      );
    case 'phone_call':
      return (
        <IconPhoneFilled
          role="img"
          width={24}
          height={24}
          aria-label="phoneFilled"
        />
      );
    case 'in_the_news':
      return (
        <IconNewspaper
          role="img"
          width={24}
          height={24}
          aria-label="newspaper"
          fill="none"
        />
      );
    case 'radio':
      return (
        <IconMicrophoneOutline
          role="img"
          width={24}
          height={24}
          aria-label="microphoneOutline"
        />
      );
    case 'train_or_bus_ad':
      return <IconBusSide role="img" width={24} height={24} aria-label="bus" />;
    case 'social_media':
      return <IconMeta role="img" width={24} height={24} aria-label="meta" />;
    case 'ai':
      return <IconAi role="img" width={24} height={24} aria-label="ai" />;
    case 'youtube':
      return (
        <IconYoutube role="img" width={24} height={24} aria-label="youtube" />
      );
    case 'events':
      return (
        <IconMultipleUsersOutline
          role="img"
          width={24}
          height={24}
          aria-label="events"
        />
      );
    case 'other':
      return (
        <IconPlusCircle
          role="img"
          width={24}
          height={24}
          aria-label="plusCircle"
        />
      );
    default:
      return null;
  }
}
